import { formatCardDateTime } from "src/utils/formatUtils";

// --- Submission Methods ---

export const SUBMISSION_METHODS: Record<string, string> = {
  R: "API",
  Q: "Quick Scrub",
  W: "Web Upload",
  F: "SFTP",
};

export const getMethodLabel = (receivedBy: string): string =>
  SUBMISSION_METHODS[receivedBy?.toUpperCase()] || receivedBy;

// --- Session Statuses ---

// These are shared with Reassigned Sessions; the backend returns statusDescription
// directly from SessionsStatuses, so this map is used only for badge coloring.
export const SESSION_STATUSES: Record<number, { name: string; badge: string }> =
  {
    1: { name: "Received", badge: "bg-secondary" },
    2: { name: "Imported", badge: "bg-info" },
    3: { name: "Queued", badge: "bg-warning text-dark" },
    4: { name: "Scrubbing", badge: "bg-info" },
    5: { name: "Finished Scrubbing", badge: "bg-info" },
    6: { name: "Generating Output", badge: "bg-info" },
    7: { name: "Completed", badge: "bg-success" },
    8: { name: "Cancelled", badge: "bg-secondary" },
    9: { name: "Identifying Reassigned Numbers", badge: "bg-info" },
    10: { name: "Exceeds Scrub Limit", badge: "bg-danger" },
    11: { name: "Invalid File Format", badge: "bg-danger" },
    12: { name: "Assistance Requested", badge: "bg-warning text-dark" },
    13: { name: "Rescrubbed", badge: "bg-success" },
    14: { name: "Retroscrubbed superceding session created", badge: "bg-success" },
    15: { name: "Calculating billable records", badge: "bg-info" },
    16: { name: "Processing", badge: "bg-info" },
    17: { name: "Exceed Credit Limit", badge: "bg-danger" },
    18: { name: "Internal Error", badge: "bg-danger" },
    19: { name: "Pre-Signed Url Error", badge: "bg-danger" },
    20: { name: "Invalid File Header", badge: "bg-danger" },
    21: { name: "Invalid File Data", badge: "bg-danger" },
    22: { name: "File Empty", badge: "bg-danger" },
    23: { name: "File Exceed Size", badge: "bg-danger" },
    24: { name: "Exceed Max Limit", badge: "bg-danger" },
  };

export const getStatusBadge = (statusId: number): string =>
  SESSION_STATUSES[statusId]?.badge || "bg-secondary";

// --- Formatting ---

export const formatTimestamp = (timestamp: string | null): string => {
  if (!timestamp) return "-";
  try {
    const date = new Date(timestamp);
    if (isNaN(date.getTime())) return "-";
    return formatCardDateTime(timestamp);
  } catch {
    return "-";
  }
};
